const OriginTypes = {
    IS_BOT: {
        rowClass: 'text-danger',
        icon: 'smart_toy',
    },
    IS_VPN: {
        rowClass: 'text-primary',
        icon: 'globe_location_pin',
    },
    IS_ANONYMOUS: {
        rowClass: 'text-orangered',
        icon: 'theater_comedy',
    },
    IS_DATACENTER: {
        rowClass: 'text-secondary',
        icon: 'dns',
    },
    IS_ABUSER: {
        rowClass: 'text-danger',
        icon: 'warning',
    },
    IS_KNOWN_ATTACKER: {
        rowClass: 'text-danger',
        icon: 'gavel',
    },
    IS_PROXY: {
        rowClass: 'text-info',
        icon: 'tune',
    },
    IS_SPAM: {
        rowClass: 'text-danger',
        icon: 'mail',
    },
    IS_TOR: {
        rowClass: 'text-purple',
        icon: 'security',
    },
    IS_ICLOUD_RELAY: {
        rowClass: 'text-primary',
        icon: 'cloud',
    },
    PAID: {
        rowClass: 'text-warning',
        icon: 'ads_click',
    },
    ORGANIC: {
        rowClass: 'text-success',
        icon: 'psychiatry',
    },
    UNKNOWN: {
        rowClass: 'text-secondary',
        icon: 'block',
    },
};

function getOriginIcon(click) {
    const { security } = click.ip?.data || {}
    if (!security) {
        return OriginTypes.UNKNOWN.icon;
    } else if (security.is_abuser) {
        return OriginTypes.IS_ABUSER.icon;
    } else if (security.is_anonymous) {
        return OriginTypes.IS_ANONYMOUS.icon;
    } else if (security.is_bot) {
        return OriginTypes.IS_BOT.icon;
    } else if (security.is_datacenter) {
        return OriginTypes.IS_DATACENTER.icon;
    } else if (security.is_icloud_relay) {
        return OriginTypes.IS_ICLOUD_RELAY.icon;
    } else if (security.is_known_attacker) {
        return OriginTypes.IS_KNOWN_ATTACKER.icon;
    } else if (security.is_proxy) {
        return OriginTypes.IS_PROXY.icon;
    } else if (security.is_spam) {
        return OriginTypes.IS_SPAM.icon;
    } else if (security.is_tor) {
        return OriginTypes.IS_TOR.icon;
    } else if (security.is_vpn) {
        return OriginTypes.IS_VPN.icon;
    } else {
        return OriginTypes.UNKNOWN.icon;
    }
}

export default getOriginIcon;
